import React from 'react'

import {
  StyledTagsWrapper,
  StyledDropsWinsTag,
  StyledExclusiveTag,
  StyledNewTag,
  StyledTag,
  StyledTopTag,
  StyledVaultTag,
} from './styles'

import hot from '../../../images/hot.svg'
import jackpot from '../../../images/jackpot.svg'
import power_hour from '../../../images/power_hour.svg'
import icon_maintenance from '../../../images/icon_maintenance.svg'
import { useTranslation } from '../../../context/translationProvider'

const GameTags = (props) => {
  const { gameTags, hideGameTags } = props

  if (hideGameTags || !gameTags?.length > 0) return <></>
  if (
    gameTags?.includes('gametag_power_week') ||
    gameTags?.includes('gametag_power_hour')
  )
    gameTags?.push('gametag_power')

  const { translate } = useTranslation()

  const availableTags = {
    gametag_drops_wins: {
      Component: StyledDropsWinsTag,
      props: {
        children: translate('games.gameTag.dropsWins', 'Drops & Wins'),
      },
    },
    gametag_vault_boost: {
      Component: StyledVaultTag,
      props: {
        children: translate('games.gameTag.vaultBoost', 'turbo cash'),
      },
    },
    gametag_exclusive: {
      Component: StyledExclusiveTag,
      props: {
        children: translate('games.gameTag.exclusive', 'Exclusive'),
      },
    },
    gametag_new: {
      Component: StyledNewTag,
      props: {
        children: translate('games.gameTag.new', 'New'),
      },
    },
    gametag_top: {
      Component: StyledTopTag,
      props: {
        children: translate('games.gameTag.top', 'Top'),
      },
    },
    gametag_hot: {
      Component: StyledTag,
      props: {
        tag: hot,
      },
    },
    gametag_daily_jackpot: {
      Component: StyledTag,
      props: {
        tag: jackpot,
      },
    },
    gametag_maintenance: {
      Component: StyledTag,
      props: {
        tag: icon_maintenance,
      },
    },
    gametag_power: {
      Component: StyledTag,
      props: {
        tag: power_hour,
      },
    },
  }
  const getTagToRender = (key, i) => {
    const TagComponent = availableTags?.[key]?.Component
    const props = availableTags?.[key]?.props
    if (!TagComponent) return <span key={`gametag-${i}`}></span>
    return <TagComponent key={`gametag-${i}`} {...props} />
  }

  return (
    <StyledTagsWrapper>
      {gameTags?.map((key, i) => getTagToRender(key, i))}
    </StyledTagsWrapper>
  )
}

export { GameTags }
